import { useEffect } from "react";

interface CustomTitleProps {
  councilName?: string;
}

export function CustomTitle({ councilName }: CustomTitleProps) {
  useEffect(() => {
    let title = "Planning Enquiry Tool";

    if (councilName) {
      title += " | " + councilName;
    }

    document.title = title;
  }, [councilName]);

  return null;
}
